export default __webpack_public_path__ + "static/media/avatar.30df7ec3.jpg";